import { infoFecthOrientacionI, makeOrientacion } from "dtos/orientaciones";
import { ENDPOINTS } from "./endpoints";
import {
  FetchCallbackI,
  getResponseWithPagination,
} from "./request/request.interface";
import { sendRequest } from "./request/request.service";
import { servicesUtils } from "./utils/services.utils";

export const getOrientaciones = async (params: any) => {
  const response = await sendRequest<
    getResponseWithPagination<infoFecthOrientacionI>
  >({
    method: "GET",
    uri: ENDPOINTS.ORIENTACIONES,
    params: servicesUtils.removeNullParamsInFilters(params),
  });

  const elementosFormated = response.elementos.map((ctElemento) =>
    makeOrientacion(ctElemento),
  );
  return {
    ...response,
    elementos: elementosFormated,
  };
};

export const postOrientacion = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthOrientacionI>({
    method: "POST",
    uri: ENDPOINTS.ORIENTACIONES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOrientacion(response);
};

export const putOrientacion = async ({ params, images }: FetchCallbackI) => {
  const response = await sendRequest<infoFecthOrientacionI>({
    method: "PUT",
    uri: ENDPOINTS.ORIENTACIONES,
    images,
    params: servicesUtils.removeNullParamsInFilters(params),
  });
  return makeOrientacion(response);
};

export const deleteOrientacion = async (id: any) => {
  const response = await sendRequest({
    method: "DELETE",
    uri: ENDPOINTS.ORIENTACIONES + "/" + id,
  });
  return response;
};
